<template>
  <div>
    <label class="ontos-field-label">{{ label }}</label>
    <!-- `mandatory` no obrigatório: depois de escolhido, dá para trocar, mas não para voltar a
         nada. Não escolhe sozinho — isso seria o `'force'` —, e é o que deixa o obrigatório vazio
         acusar ao salvar. -->
    <v-btn-toggle :model-value="answer" :mandatory="required" divided density="comfortable"
                  variant="outlined" @update:model-value="$emit('change', $event === undefined ? null : $event)">
      <v-btn v-for="option in OPTIONS" :key="String(option)" :value="option" :readonly="readonly"
             :disabled="loading" :color="faceOf(option).color">
        <v-icon start>{{ faceOf(option).icon }}</v-icon>{{ faceOf(option).label }}
      </v-btn>
    </v-btn-toggle>
    <!-- O grupo de botões não tem o `loading` dos campos do Vuetify: a mesma barra fina, embaixo -->
    <v-progress-linear v-if="loading" indeterminate height="2" color="primary"/>
    <v-messages v-if="errorMessage" active :messages="errorMessage" color="error" class="mt-1" role="alert"/>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue, toNative} from 'vue-facing-decorator'
import {booleanFace, isEmpty} from '@/utils/propertyDisplay'
import {asBoolean} from '@/utils/utils'

/**
 * O campo de sim/não: dois botões, ✓ Sim e ✗ Não, com a cara da exibição (`booleanFace`).
 *
 * Dois botões, e não uma caixa de marcar, porque o campo tem TRÊS estados — Sim, Não e nada
 * escolhido —, e a caixa mostrava "nada" e "Não" iguais. Obrigatório é ter escolhido um dos dois, e
 * Não é escolha (decisão do usuário); fora do obrigatório, clicar de novo no escolhido o desfaz.
 *
 * O rótulo e a mensagem por fora, como o campo de markdown e o de mídia: o grupo de botões não é um
 * campo do Vuetify, e não os desenha.
 */
@Component({name: 'ontos-boolean-input', emits: ['change']})
class BooleanInput extends Vue {
  //Exposto ao template: Sim antes de Não, a ordem em que se lê
  OPTIONS = [true, false]

  @Prop({type: String, default: ''}) readonly label!: string
  @Prop({default: null}) readonly value!: any
  @Prop({type: Boolean, default: false}) readonly required!: boolean
  @Prop({type: Boolean, default: false}) readonly readonly!: boolean
  /** A prévia vai mudar o valor (ver o `InstanceInput.affectedBy`): travado, com progresso. */
  @Prop({type: Boolean, default: false}) readonly loading!: boolean
  @Prop({type: String, default: ''}) readonly errorMessage!: string

  /** A escolha, ou nada — o gravado pode vir como texto ("true") de dado antigo. */
  get answer(): boolean | undefined {
    return isEmpty(this.value) ? undefined : asBoolean(this.value)
  }

  faceOf(option: boolean) {
    return booleanFace(option)
  }
}

export default toNative(BooleanInput)
</script>
